<template>
	<V2Modal
		:modal-name="modalName"
		type="dialog"
		@closing-modal="handleClosingModal"
		@opened="onOpen"
	>
		<template #title>
			{{ title }}
		</template>
		<template #content>
			<span v-html="text" />
		</template>
		<template #footer>
			<div class="l-button-group">
				<V2Button
					:text="$Helpers.ucfirst($I18n.trans('commons.cancel'))"
					modifier="secondary"
					@click="handleCancel"
				/>
				<V2Button
					:text="confirmButtonText"
					:modifier="confirmButtonModifier"
					@click="handleConfirm"
				/>
			</div>
		</template>
	</V2Modal>
</template>

<script>
import V2Button from '@shared/components/Button';
import V2Modal from '@shared/components/Modal';

export default {
	name:       'ModalConfirm',
	components: { V2Button, V2Modal },
	props:      {
		modalName: {
			type:     String,
			required: true,
		},
		title: {
			type:     String,
			required: true,
		},
		text: {
			type:     String,
			required: true,
		},
		confirmButtonText: {
			type:     String,
			required: true,
		},
		confirmButtonModifier: {
			type:    String,
			default: 'primary',
		},
	},
	data() {
		return {
			buttonWasClicked: false,
			passedData:       null,
		};
	},
	methods: {
		handleCancel() {
			this.buttonWasClicked = true;
			this.$emit('cancelled');
			window.eventBus.$emit(`modalClose:${this.modalName}`);
			window.eventBus.$emit(`confirmationMessage:${this.modalName}`, false);
		},
		handleConfirm() {
			this.buttonWasClicked = true;
			this.$emit('confirmed', this.passedData);
			window.eventBus.$emit(`modalClose:${this.modalName}`, { confirmed: true });
			window.eventBus.$emit(`confirmationMessage:${this.modalName}`, true);
		},
		handleClosingModal() {
			if (!this.buttonWasClicked) {
				window.eventBus.$emit(`confirmationMessage:${this.modalName}`, false);
			}
			this.$emit('closing-modal');
		},
		onOpen(data) {
			this.passedData = data;
		},
	},
};
</script>

<style lang="scss" scoped>
</style>
